import script from "./VettingParticipation.vue?vue&type=script&setup=true&lang=js"
export * from "./VettingParticipation.vue?vue&type=script&setup=true&lang=js"

import "./VettingParticipation.vue?vue&type=style&index=0&id=4bf0aa13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf0aa13"]])

export default __exports__